module.exports = __webpack_public_path__ + "img/fig35.3539c433.jpg";